import React, { Component, Fragment } from "react";
import Grid from "@material-ui/core/Grid";
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Button, TextField, MenuItem, withStyles, Checkbox, Typography } from "@material-ui/core";
import AuthenticationService from "../../Services/AuthenticationService.js";
import './UserProfile.css';
//import AddUserTinListTable from "./AddUserTinListTable.js";
import AddUserTinSection from "./AddUserTinSection.js";
import { isNotEmpty, isAlpha, isEmailAddress, validatePhone, hasLength, isName, isEmpty } from '../../utils/Validator.js';
import LoadingMsgBar from "../LoadingMsgBar.js";
import GlobalMessage from "../GlobalMessage.js";
import AddUserGroupTINSTable from './AddUserGroupTINSTable.js';

const styles = () => ({
    root: {
        width: '100%',
    },

});
window.analytics = { pageName: 'Add User' };
class AddUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mode: 'newUser',
            skipEmailValidation: true,
            userDetailsInfo: null, firstName: '', lastName: '', middleInitial: '', phoneNumber: '', isPhoneNumValid: true,
            emailAddress: '', enlyteEmpId: '',
            securityQuestionList: [], secQuestionId: 1, accountTypeList: [], accountType: 'Select One',
            valid: true, securityQuestion: '',
            progMsg: '', successMsg: '', errorMsg: '', loadingMessage: '',
            isCreateUserButtonEnabled: true, isSaveDraftButtonEnabled: false, affiliation: 'Select One', affiliationList: [],
            showTinDlg: false, showDlgOkCancel: false, dlgMsg: '', tin: '', selectedTINs: [], showTINTable: false, providersTINs: [], selectedPrv: [],
            groupAssignment: 'new', tins: [], filteredTins: [], grpId: '', isMirror: false, selected: [], loadTinsTable: false, showGroupTINTable: false,
            jobTitle: '', companyName: '', companyUrl: '', selectedGroupTINS: [], showTextFields: false, showGroupId: true, nnusTins: [],
            tinSectionResetKey: 0,
            isSaveAsDraftOperation: false,
            selectedRosterSources: [], // Track selected roster sources when returning from ManageRosterSourcesForUserGroup
            providerDemographicsMaintenance: false,
        }

        this.usrfirstnameInput = React.createRef();
    };

    componentDidMount() {
        console.log('AddUser componentDidMount - location state:', this.props.location?.state);

        // Check if we're returning from another page with state data
        const returnData = this.props.location?.state;

        if (returnData) {
            // Log received data for debugging
            console.log('Received data in AddUser componentDidMount:', returnData);

            // Check if we need to display a success message
            if (returnData.successMsg) {
                console.log('Setting success message:', returnData.successMsg);
                this.setState({
                    successMsg: returnData.successMsg
                });
            }

            // If we're returning from saving a draft and should show a blank form
            if (returnData.saveDraftSuccess) {
                console.log('Returning after successful draft save');
            }

            // Handle data from ManageRosterSourcesForUserGroup (new format)
            if (returnData.formData) {
                console.log('Found form data from ManageRosterSourcesForUserGroup:', returnData.formData);

                // Retrieve the form data with a direct reference
                const formData = returnData.formData;

                // Check for updated groupInfo when returning from ManageRosterSourcesForUserGroup
                let updatedGroupInfo = returnData.groupInfo || formData.groupInfo;

                // If we're returning from roster sources page, make sure the roster sources are properly preserved
                if (returnData.returningFromAddGroup && updatedGroupInfo && updatedGroupInfo.groupRosterSources) {
                    console.log('Returning from ManageRosterSourcesForUserGroup with updated roster sources:',
                        updatedGroupInfo.groupRosterSources);
                }

                // Restore all form fields from the saved data with a single setState
                this.setState({
                    // User details
                    id: formData.id,
                    firstName: formData.firstName || '',
                    lastName: formData.lastName || '',
                    middleInitial: formData.middleInitial || '',
                    phoneNumber: formData.phoneNumber || '',
                    emailAddress: formData.emailAddress || '',
                    enlyteEmpId: formData.enlyteEmpId || '',

                    // Account settings
                    accountType: formData.accountType || 'Select One',
                    affiliation: formData.affiliation || 'Select One',
                    jobTitle: formData.jobTitle || '',
                    companyName: formData.companyName || '',
                    companyUrl: formData.companyUrl || '',

                    // Group assignment settings
                    groupAssignment: formData.groupAssignment || 'new',
                    grpId: formData.grpId || '',
                    mgrUserInfoId: formData.mgrUserInfoId,
                    // Application state
                    mode: formData.mode || 'newUser',
                    groupInfo: updatedGroupInfo,

                    // Roster sources - use the most up-to-date ones
                    selectedRosterSources: formData.selectedRosterSources ||
                        (updatedGroupInfo && updatedGroupInfo.groupRosterSources) || [],

                    // UI state based on account type
                    showTextFields: (formData.accountType && formData.accountType !== 'Select One') && !returnData.saveDraftSuccess,
                    isSaveDraftButtonEnabled: formData.accountType === 'ROAD' || formData.accountType === 'ROUS',
                    isCreateUserButtonEnabled: !(formData.accountType === 'ROAD' || formData.accountType === 'ROUS'),

                    // Maintenance privileges
                    providerDemographicsMaintenance: formData.providerDemographicsMaintenance || false,
                });

                // Load dropdown options
                this.loadAccountTypes();
                this.loadAffiliationList();
                this.getUser();
                return; // Skip the standard initialization
            }
            // Handle data from UserSearch (addUserFormData format)
            else if (returnData.addUserFormData) {
                console.log('Found addUserFormData from UserSearch:', returnData.addUserFormData);

                // Retrieve the form data
                const formData = returnData.addUserFormData;

                // Restore all form fields from the saved data
                this.setState({
                    // User details
                    firstName: formData.firstName || '',
                    lastName: formData.lastName || '',
                    middleInitial: formData.middleInitial || '',
                    phoneNumber: formData.phoneNumber || '',
                    emailAddress: formData.emailAddress || '',
                    enlyteEmpId: formData.enlyteEmpId || '',

                    // Account settings
                    accountType: formData.accountType || 'Select One',
                    affiliation: formData.affiliation || 'Select One',
                    jobTitle: formData.jobTitle || '',
                    companyName: formData.companyName || '',
                    companyUrl: formData.companyUrl || '',

                    // Group assignment settings
                    groupAssignment: formData.groupAssignment || 'existing',
                    grpId: formData.grpId || '',

                    // Application state - for draft user mode
                    mode: formData.mode || returnData.mode || 'newUser',
                    groupInfo: formData.groupInfo || returnData.groupInfo,

                    // UI state 
                    showTextFields: true,
                    isSaveDraftButtonEnabled: true,
                    isCreateUserButtonEnabled: false,

                    // Maintenance privileges
                    providerDemographicsMaintenance: formData.providerDemographicsMaintenance || false,
                });

                console.log('Set state with data from UserSearch, mode:', formData.mode || returnData.mode);

                // Load dropdown options
                this.loadAccountTypes();
                this.loadAffiliationList();
                this.getUser();
                return; // Skip the standard initialization
            }
            // Handle user data directly
            else if (returnData.user) {
                console.log('Found user data from UserSearch:', returnData.user);
                const user = returnData.user;

                // Set the application mode
                const mode = returnData.mode || 'newUser';

                this.setState({
                    firstName: user.userFirstName || '',
                    lastName: user.userLastName || '',
                    middleInitial: user.userMidName || '',
                    phoneNumber: user.phoneNum || '',
                    emailAddress: user.emailAddr || '',
                    accountType: user.typeCd || 'Select One',
                    groupAssignment: 'existing',
                    grpId: user.grpInfoId || '',
                    jobTitle: user.jobTitle || '',
                    companyName: user.companyNm || '',
                    mode: mode,
                    groupInfo: user.groupInfo,
                    showTextFields: true,
                    isSaveDraftButtonEnabled: mode === 'draftUser',
                    isCreateUserButtonEnabled: mode !== 'draftUser',

                    // Maintenance privileges
                    providerDemographicsMaintenance: user.privilegedFunctions && Array.isArray(user.privilegedFunctions)
                        ? user.privilegedFunctions.includes("DMGMNT")
                        : false,
                });

                console.log('Set state with user data, mode:', mode);

                this.loadAccountTypes();
                this.loadAffiliationList();
                this.getUser();
                return;
            }
        }

        // Standard initialization for a fresh page load
        this.loadAccountTypes();
        this.loadAffiliationList();
        this.setState({ accountType: 'Select One' });
        this.setState({ affiliation: 'Select One' });
        this.getUser();
        this.setState({
            isCreateUserButtonEnabled: true,
            isSaveDraftButtonEnabled: false
        });
    };

    // Determine if the Maintenance Privileges section should be shown
    // Only shows when the logged-in user is ISAD and account type is PRAD or PRUS
    shouldShowMaintenancePrivileges() {
        const loggedInUser = this.state.userDetailsInfo;
        const accountType = this.state.accountType;
        return loggedInUser?.typeCd === "ISAD" && (accountType === "PRAD" || accountType === "PRUS");
    }

    showProcessingIndicator(shouldShow) {
        this.setState({ loadingMessage: shouldShow === true ? `Please wait while we validate the TIN.` : '' });
    }

    addErrorMessage(fieldName, errorMessage) {
        this.setState({
            [fieldName]: errorMessage
        });
    }

    clearErrorMessage(fieldName) {
        this.setState({
            [fieldName]: ''
        });
    }

    setErrorMsg = () => {
        this.setState({ progMsg: '', errorMsg: `Error:  An error has occurred.  Please try again or contact Customer Service.` })
    }

    clearErrorMessages() {
        const errorFieldList = [

            'firstNameError',
            'lastNameError',
            'middleInitialError',
            'phoneNumberError',
            'emailAddressError',
            'enlyteEmpIdError',
            'accountTypeError',
            'grpIdError',
            'affiliationError',
            'jobTitleError',
            'companyNameError', 'nnusTinError'
        ];

        errorFieldList.forEach(errorFieldName => {
            this.clearErrorMessage(errorFieldName);
        });
    }

    // save any changes the user makes into the state variable so you can
    // get back to the state the user was in
    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    handleAccountTypeChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checkecd : target.value;
        const name = target.name;
        this.handleReset();
        this.setState({
            [name]: value,
            providerDemographicsMaintenance: false // Reset when account type changes
        });
        if (value !== 'Select One') {
            this.setState({ showTextFields: true });

            // Enable Save Draft button only for ROAD and ROUS account types
            // and disable Create User button for these types
            if (value === 'ROAD' || value === 'ROUS') {
                this.setState({
                    isSaveDraftButtonEnabled: true,
                    isCreateUserButtonEnabled: false
                });
            } else {
                this.setState({
                    isSaveDraftButtonEnabled: false,
                    isCreateUserButtonEnabled: true
                });
            }
        }
        else {
            this.setState({
                showTextFields: false,
                isSaveDraftButtonEnabled: false,
                isCreateUserButtonEnabled: true,
                providerDemographicsMaintenance: false,
            });
        }
    }

    getFormData() {
        const plainPhoneNm = this.state.phoneNumber.replace(/[^\d]/g, "");
        let selectedFtins = [];
        if (((this.state.accountType === 'PRAD') && (this.state.groupAssignment === 'new'))) {
            if (isNotEmpty(this.state.providersTINs)) {
                this.state.providersTINs.forEach(provTIN => {
                    selectedFtins.push({
                        ftin: provTIN.ftin,
                    });
                });
            }
            console.log(selectedFtins);
            // userFtins:[{"ftin":"160743029"},{"ftin":"231352213"}]
        }

        if (((this.state.accountType === 'PRUS'))) {
            if (isNotEmpty(this.state.selectedGroupTINS)) {
                this.state.selectedGroupTINS.forEach(selTIN => {
                    selectedFtins.push({
                        ftin: selTIN,
                    });
                });
            }
            console.log(selectedFtins);
            // userFtins:[{"ftin":"160743029"},{"ftin":"231352213"}]
        }

        if (((this.state.accountType === 'NNUS'))) {
            if (isNotEmpty(this.state.nnusTins)) {
                this.state.nnusTins.forEach(selTIN => {
                    selectedFtins.push({
                        ftin: selTIN.ftin
                    });
                });
            }
            console.log(selectedFtins);
            // userFtins:[{"ftin":"160743029"},{"ftin":"231352213"}]
        }

        // Prepare group and roster sources for ROAD and ROUS account types
        let groupInfo = {};
        if ((this.state.accountType === 'ROAD' || this.state.accountType === 'ROUS') &&
            this.state.selectedRosterSources &&
            this.state.selectedRosterSources.length > 0) {

            console.log('Including roster sources in form data:', this.state.selectedRosterSources);

            // Format roster sources for the API
            const formattedRosterSources = this.state.selectedRosterSources.map(source => ({
                sourceId: source.sourceId || source.id,
                sourceName: source.sourceName
            }));

            groupInfo = {
                groupInfoId: this.state.grpId,
                groupRosterSources: formattedRosterSources
            };
        }

        // Build privilegedFunctions array based on checkbox state
        const privilegedFunctions = [];
        if (this.state.providerDemographicsMaintenance) {
            privilegedFunctions.push("DMGMNT");
        }

        return {
            id: this.state.id,
            isSaveAsDraftOperation: this.state.isSaveAsDraftOperation,
            userFirstName: this.state.firstName.trim(),
            userLastName: this.state.lastName.trim(),
            userMidName: this.state.middleInitial.trim(),
            emailAddr: this.state.emailAddress.trim(),
            phoneNum: plainPhoneNm,
            typeCd: this.state.accountType.trim(),
            //grpInfoId: this.state.userDetailsInfo.grpInfoId,
            grpInfoId: this.state.grpId,
            mgrUserInfoId: this.state.userDetailsInfo?.id,
            statusDesc: this.state.userDetailsInfo?.userNm,
            //userFtins:[{"ftin":"160743029"},{"ftin":"231352213"}],
            userFtins: selectedFtins,
            employeeId: ((this.state.enlyteEmpId === "") ? null : this.state.enlyteEmpId),
            // Only include affiliation for PRAD, PRUS, and NNUS account types
            affiliationCd: ((this.state.accountType === 'ROAD' || this.state.accountType === 'ROUS') ?
                null :
                ((this.state.affiliation === "Select One") ? '' : this.state.affiliation)),
            affiliationDesc: ((this.state.accountType === 'ROAD' || this.state.accountType === 'ROUS') ?
                null :
                this.state.other),
            jobTitle: this.state.jobTitle,
            companyNm: this.state.companyName,
            // Only include companyUrl for account types other than ROAD and ROUS
            companyUrl: (this.state.accountType === 'ROAD' || this.state.accountType === 'ROUS') ? null : this.state.companyUrl,
            // Include group info with roster sources for ROAD and ROUS
            groupInfo: (this.state.accountType === 'ROAD' || this.state.accountType === 'ROUS') ? groupInfo : undefined,
            // Include selected roster sources directly for backward compatibility
            selectedRosterSources: this.state.selectedRosterSources || [],
            // Always include current mode
            mode: this.state.mode || 'newUser',
            // Include privileged functions
            privilegedFunctions: privilegedFunctions,
        }
    }

    handleReset = () => {
        this.clearErrorMessages();
        this.setState({
            firstName: '', lastName: '', middleInitial: '', phoneNumber: '', isPhoneNumValid: true,
            emailAddress: '', enlyteEmpId: '', accountType: '', affiliation: 'Select One',
            valid: true, securityQuestion: '',
            progMsg: '', successMsg: '', errorMsg: '', loadingMessage: '',
            isCreateUserButtonEnabled: true, isSaveDraftButtonEnabled: false,
            affiliationList: [],
            showTinDlg: false, showDlgOkCancel: false, dlgMsg: '', tin: '', selectedTINs: [], showTINTable: false, providersTINs: [], selectedPrv: [],
            groupAssignment: 'new', tins: [], filteredTins: [], grpId: '', isMirror: false, selected: [], loadTinsTable: false, showGroupTINTable: false,
            jobTitle: '', companyName: '', companyUrl: '', selectedGroupTINS: [], showTextFields: false, showGroupId: true, nnusTins: [],
            tinSectionResetKey: this.state.tinSectionResetKey + 1,
            isSaveAsDraftOperation: false,
            // Also clear any selected roster sources
            selectedRosterSources: [],
            // Reset maintenance privileges
            providerDemographicsMaintenance: false,
        });

        // Clear any roster sources from location state if they exist
        if (this.props.location && this.props.location.state) {
            if (this.props.location.state.selectedRosterSources) {
                this.props.location.state.selectedRosterSources = [];
            }

            if (this.props.location.state.addUserFormData &&
                this.props.location.state.addUserFormData.selectedRosterSources) {
                this.props.location.state.addUserFormData.selectedRosterSources = [];
            }

            console.log('Reset in AddUser: cleared roster sources from state and navigation data');
        }

        this.loadAccountTypes();
        this.loadAffiliationList();
        this.setState({ accountType: 'Select One' });
        this.setState({ affiliation: 'Select One' });
    }

    setSelectedGroupTINS = (selected) => {
        this.setState({ selectedGroupTINS: selected })

    }

    handleCreateUserError = (errorData) => {
        // Re-enable buttons on error
        this.setState({
            isCreateUserButtonEnabled: this.state.accountType !== 'ROAD' && this.state.accountType !== 'ROUS',
            isSaveDraftButtonEnabled: this.state.accountType === 'ROAD' || this.state.accountType === 'ROUS'
        });

        // Handle specific error cases
        if (errorData && errorData.message === 'INVALID_ENLYTE_EMPLOYEE_ID') {
            this.setState({ enlyteEmpIdError: `Error: Enter a valid Enlyte Employee ID.` });
            //this.addErrorMessage("enlyteEmpIdError", "Error: Enter a valid Enlyte Employee ID");
        } else {
            // Default error message
            this.setState({ errorMsg: `Error: An error has occurred. Please try again or contact Customer Service.` });
        }
    }

    createUser = () => {
        console.log(`create new user ===>${JSON.stringify(this.getFormData())}`)
        const newUserDetails = this.getFormData();
        AuthenticationService.createNewUser(newUserDetails)
            .then(response => {
                // Handle successful 200 response
                if (response.status === 200) {
                    this.handleReset();
                    this.setState({ successMsg: 'User has been successfully created!' })
                }
                // Handle error responses that come through as resolved promises (due to axios interceptor)
                else if (response.response && response.response.status === 400) {
                    this.handleCreateUserError(response.response.data);
                }
                // Handle any other non-200 status
                else {
                    this.handleCreateUserError(null);
                }
            }).catch((error) => {
                // Handle actual promise rejections (network errors, etc.)
                this.handleCreateUserError(error.response?.data);
                console.log(`create user error: ${error.message || error}`);
            })
    }

    saveDraftUser = (doCompleteProfile) => {
        const newUserDetails = this.getFormData();
        // Add the doCompleteProfile flag if provided
        if (doCompleteProfile !== undefined) {
            newUserDetails.completeProfile = doCompleteProfile;
        }
        console.log(`save draft user ===>${JSON.stringify(newUserDetails)}`)
        AuthenticationService.saveDraftUser(newUserDetails)
            .then(response => {
                // Handle successful 200 response
                if (response.status === 200) {
                    this.handleReset();
                    this.setState({ successMsg: 'User has been successfully saved!' })
                }
                // Handle error responses that come through as resolved promises (due to axios interceptor)
                else if (response.response && response.response.status === 400) {
                    this.handleCreateUserError(response.response.data);
                }
                // Handle any other non-200 status
                else {
                    this.handleCreateUserError(null);
                }
            }).catch((error) => {
                // Handle actual promise rejections (network errors, etc.)
                this.handleCreateUserError(error.response?.data);
                console.log(`save draft user error: ${error.message || error}`);
            })
    }

    saveUser = () => {
        this.setState({ errorMsg: '', successMsg: '' });
        const isValidSyntax = this.doSyntaxValidation();

        if (isValidSyntax) {
            // Disable both buttons immediately to prevent multiple clicks
            if (this.state.accountType === 'ROAD') {
                this.setState({ isSaveDraftButtonEnabled: false, isCreateUserButtonEnabled: false });
            }
            else {
                this.setState({ isCreateUserButtonEnabled: false, isSaveDraftButtonEnabled: false });
            }

            // Check if email validation should be skipped
            if (this.state.skipEmailValidation) {
                // Skip email check and save directly
                if (this.state.mode === 'draftUser') {
                    this.saveDraftUser(!this.state.isSaveAsDraftOperation);
                }
                else {
                    if (this.state.isSaveAsDraftOperation) {
                        this.saveDraftUser(!this.state.isSaveAsDraftOperation);
                    } else {
                        this.createUser();
                    }
                }
                return;
            }

            const emailaddr = this.state.emailAddress;
            AuthenticationService.checkEmailAddressExists(emailaddr).then((response) => {
                const emailExist = response.data;
                if (emailExist && !this.state.isSaveAsDraftOperation) {
                    // Re-enable buttons on validation error
                    this.setState({
                        isCreateUserButtonEnabled: this.state.accountType !== 'ROAD' && this.state.accountType !== 'ROUS',
                        isSaveDraftButtonEnabled: this.state.accountType === 'ROAD' || this.state.accountType === 'ROUS',
                        errorMsg: `An error has occurred. Please address all fields marked with «Error».`,
                        emailAddressError: `Error: The Email Address is associated to another account`
                    });
                } else {
                    if (this.state.mode === 'draftUser') { //saving existing draft user
                        this.saveDraftUser(!this.state.isSaveAsDraftOperation); //updateDraftUser();
                    }
                    else {
                        if (this.state.isSaveAsDraftOperation) { //creating new draft user
                            this.saveDraftUser(!this.state.isSaveAsDraftOperation);
                        } else { //creating new user
                            this.createUser();
                        }
                    }
                }
            }, (error) => {
                console.log(error);
                // Re-enable buttons on error
                this.setState({
                    progMsg: '',
                    errorMsg: `Error: An error has occurred. Please try again or contact Customer Service.`,
                    isCreateUserButtonEnabled: this.state.accountType !== 'ROAD' && this.state.accountType !== 'ROUS',
                    isSaveDraftButtonEnabled: this.state.accountType === 'ROAD' || this.state.accountType === 'ROUS'
                })
            });
        }
        else {
            this.setState({ errorMsg: `An error has occurred. Please address all fields marked with "Error".` });
        }
    }

    handleSave = () => {
        this.setState({ isSaveAsDraftOperation: false }, () => {
            this.saveUser();
        });
    }

    handleSaveDraft = () => {
        this.setState({ isSaveAsDraftOperation: true }, () => {
            this.saveUser();
        });
    }

    // Navigate to ManageGroup page ( NEXT button click )
    // Support back and forth navigation with the AddUser state 
    // Next page should be able to save the user data
    gotoGroupPage = () => {
        // Clear existing error messages
        this.setState({ errorMsg: '', successMsg: '' });

        // Validate the user input before navigating
        const isValidSyntax = this.doSyntaxValidation();

        if (isValidSyntax) {
            // Create a single, consistent form data object with all necessary fields
            const formData = {
                // User details
                id: this.state.id,
                firstName: this.state.firstName.trim(),
                lastName: this.state.lastName.trim(),
                middleInitial: this.state.middleInitial.trim(),
                phoneNumber: this.state.phoneNumber,
                emailAddress: this.state.emailAddress.trim(),
                enlyteEmpId: this.state.enlyteEmpId,

                // Account and group settings
                accountType: this.state.accountType,
                typeCd: this.state.accountType,
                affiliation: this.state.affiliation,
                jobTitle: this.state.jobTitle,
                companyName: this.state.companyName,
                companyUrl: this.state.companyUrl,

                // Group assignment settings
                groupAssignment: this.state.groupAssignment,
                grpId: this.state.grpId,
                mgrUserInfoId: this.state.mgrUserInfoId,
                // Reference to logged-in user
                loggedInUserInfo: this.state.userDetailsInfo,

                // Any previously selected roster sources
                selectedRosterSources: this.state.selectedRosterSources || [],

                // Current mode (for tracking draft vs new)
                mode: this.state.mode || 'newUser',

                // Maintenance privileges
                providerDemographicsMaintenance: this.state.providerDemographicsMaintenance,
            };

            console.log('Navigating to ManageRosterSourcesForUserGroup with form data:', formData);

            // Prepare groupInfo with roster sources for draft users
            let groupInfoToPass = this.state.groupInfo;

            // If this is a draft user and we have roster sources, make sure they're included in groupInfo
            if (this.state.mode === 'draftUser' && this.state.selectedRosterSources?.length > 0) {
                // Create or enhance the groupInfo object
                groupInfoToPass = {
                    ...(groupInfoToPass || {}),
                    // Format roster sources as expected by loadUserRosterSources
                    groupRosterSources: this.state.selectedRosterSources.map(source => {
                        // If it's already in the right format, use as is
                        if (typeof source === 'object' && source.sourceId) {
                            return source;
                        }
                        // If it's just a sourceId, convert to object
                        return { sourceId: source };
                    }),
                    grpInfoId: this.state.grpId
                };
                console.log('Enhanced groupInfo with roster sources for draft user:', groupInfoToPass);
            }

            // Preserve the original return path if it exists (typically from UserSearch)
            const originalReturnPath = this.props.location?.state?.returnPath || '/wcpp/UserSearch';
            const searchInfo = this.props.location?.state?.searchInfo;

            console.log('Preserving original return path:', originalReturnPath);
            console.log('Preserving search info for return to UserSearch:', searchInfo);

            // Navigate to the ManageRosterSourcesForUserGroup page with a cleaner, more consistent state object
            this.props.history.push({
                pathname: '/wcpp/ManageRosterSourcesForUserGroup',
                state: {
                    formData: formData, // Use a consistent key for form data
                    mode: this.state.mode === 'draftUser' ? 'draftGroup' : 'newGroup',
                    groupInfo: groupInfoToPass,
                    returnPath: '/wcpp/AddUser', // Immediate return is to AddUser
                    originalReturnPath: originalReturnPath, // But the original source was UserSearch
                    searchInfo: searchInfo, // Preserve search info for returning to UserSearch
                    timestamp: new Date().getTime() // Add timestamp to ensure state changes are detected
                }
            });
        } else {
            // Show error message if validation fails
            this.setState({ errorMsg: `An error has occurred. Please address all fields marked with "Error".` });
        }
    }

    handleOnBlurPhoneNum = (event) => {
        const changed = event.target.value;
        this.setState({ phoneNumber: changed });
        if (changed.length < 10) {

            this.setState({ valid: false });
        }
        else {
            const phone = validatePhone(changed)
            if (phone.length < 10) {

                this.setState({ valid: false });
            }
            else {
                this.setState({ phoneNumber: phone });
                this.setState({ isPhoneNumValid: true, valid: true, phoneNumberError: '' });
            }
        }
    }

    doSyntaxValidation() {
        let isValid = true;
        this.clearErrorMessages();

        if (this.state.accountType === 'Select One') {
            this.addErrorMessage("accountTypeError", "Error: Select Account Type");
            return false;
        }

        if (!isName(this.state.firstName) || !hasLength(this.state.firstName, 1, 40)) {
            this.addErrorMessage("firstNameError", "Error: Enter valid First Name");
            isValid = false;
        }

        if (!isName(this.state.lastName) || !hasLength(this.state.lastName, 1, 40)) {
            this.addErrorMessage("lastNameError", "Error: Enter valid Last Name");
            isValid = false;
        }

        if (isNotEmpty(this.state.middleInitial) && !isAlpha(this.state.middleInitial)) {
            this.addErrorMessage("middleInitialError", "Error: Enter Middle Initial");
            isValid = false;
        }
        if (((this.state.accountType === 'PRAD') && (this.state.groupAssignment === 'existing')) ||
            ((this.state.accountType === 'ROAD') && (this.state.groupAssignment === 'existing')) ||
            (this.state.accountType === 'PRUS') ||
            (this.state.accountType === 'ROUS')) {
            if (this.state.mode !== 'draftUser') {
                if (isEmpty(this.state.grpId)) {
                    this.addErrorMessage("grpIdError", "Error: Enter a valid group Id");
                    isValid = false;
                }
                if (isNotEmpty(this.state.grpId) && isAlpha(this.state.grpId)) {
                    this.addErrorMessage("grpIdError", "Error: Enter a valid group Id");
                    isValid = false;
                }
            }
        }

        if (validatePhone(this.state.phoneNumber) === '') {
            this.addErrorMessage("phoneNumberError", "Error: Enter a valid Phone Number");
            isValid = false;
        }
        if (((this.state.accountType === 'ISAD') || (this.state.accountType === 'IRAD'))) {
            if (isEmpty(this.state.enlyteEmpId)) {
                this.addErrorMessage("enlyteEmpIdError", "Error: Enter a valid Enlyte Employee ID");
                isValid = false;
            }
        }

        if (!isEmailAddress(this.state.emailAddress)) {
            this.addErrorMessage("emailAddressError", "Error: Enter a valid Email Address");
            isValid = false;
        }

        if ((this.state.accountType === 'PRAD') || (this.state.accountType === 'PRUS') || (this.state.accountType === 'NNUS')) {
            if (this.state.affiliation === 'Select One') {
                this.addErrorMessage("affiliationError", "Error: Select Affiliation");
                isValid = false;
            }
            if (isEmpty(this.state.jobTitle)) {
                this.addErrorMessage("jobTitleError", "Error: Enter a valid Job Title");
                isValid = false;
            }

            if (isEmpty(this.state.companyName)) {
                this.addErrorMessage("companyNameError", "Error: Enter a valid Company Name");
                isValid = false;
            }
        }

        // Job Title and Company Name validation for ROAD and ROUS account types
        if ((this.state.accountType === 'ROAD') || (this.state.accountType === 'ROUS')) {
            if (isEmpty(this.state.jobTitle)) {
                this.addErrorMessage("jobTitleError", "Error: Enter a valid Job Title");
                isValid = false;
            }

            if (isEmpty(this.state.companyName)) {
                this.addErrorMessage("companyNameError", "Error: Enter a valid Company Name");
                isValid = false;
            }
        }

        if ((this.state.accountType === 'PRUS')) {
            if (isEmpty(this.state.selectedGroupTINS)) {
                this.addErrorMessage("grpIdError", "Error: Select TIN");
                isValid = false;
            }
        }
        if (this.state.accountType === 'NNUS' && (this.state.groupAssignment === 'new') && this.state.nnusTins.length === 0) {
            this.addErrorMessage('nnusTinError', 'Error: Add at least one Tax ID Number (TIN)');
            isValid = false;
        }

        if (this.state.accountType === 'NNUS' && (this.state.groupAssignment === 'existing') && this.state.grpId.length === 0) {
            this.addErrorMessage('grpIdError', 'Error: Enter a valid group Id');
            isValid = false;
        }

        return isValid;

    }

    getUser = () => {

        AuthenticationService.getUsrDtls(AuthenticationService.getLoggedInUserName())
            .then((response) => {
                this.setState({ userDetailsInfo: response.data });
                console.log(`header user dtls'===>${JSON.stringify(this.state.userDetailsInfo)}`);
            }).catch(function (error) {
                console.log('header getting usr dtl error:' + error);
            })
        return true
    }

    loadAccountTypes() {
        const accountTypList = [];
        //let typeList = null;

        accountTypList.push({
            value: 'IRAD',
            label: 'Internal Read-Only Admin'
        });
        accountTypList.push({
            value: 'ISAD',
            label: 'Internal System Admin'
        });
        accountTypList.push({
            value: 'NNUS',
            label: 'Non-Network User'
        });
        accountTypList.push({
            value: 'PRAD',
            label: 'Provider Admin'
        });
        accountTypList.push({
            value: 'PRUS',
            label: 'Provider User'
        });
        accountTypList.push({
            value: 'ROAD',
            label: 'Roster Admin'
        });
        // accountTypList.push({
        //     value: 'ROUS',
        //     label: 'Roster User'
        // });

        this.setState({ accountTypeList: accountTypList });
        return;
    }

    loadAffiliationList() {
        const affilList = [];
        affilList.push({
            value: 'OFC_STAFF',
            label: 'Provider or facility employee'
        });
        affilList.push({
            value: 'BILLING_CO',
            label: '3rd party billing employee'
        });
        affilList.push({
            value: 'OTHER',
            label: 'Other'
        });

        this.setState({ affiliationList: affilList });

    }

    handleCancel = () => {
        // Check if we have location state information
        if (this.props.location && this.props.location.state) {
            // If we have an explicit returnPath, use it
            if (this.props.location.state.returnPath) {
                // If we came from UserSearch, go back there with the search info
                this.props.history.push({
                    pathname: this.props.location.state.returnPath,
                    state: {
                        searchInfo: this.props.location.state.searchInfo
                    }
                });
                console.log('Navigating back to explicit returnPath: ' + this.props.location.state.returnPath);
                return;
            }

            // If we're working with a draft user, this almost certainly came from UserSearch
            if (this.state.mode === 'draftUser') {
                // Go back to UserSearch with any search information we might have
                this.props.history.push({
                    pathname: '/wcpp/UserSearch',
                    state: {
                        searchInfo: this.props.location.state.searchInfo || {
                            userName: '',
                            email: '',
                            tin: '',
                            typeCD: '',
                            groupId: ''
                        }
                    }
                });
                console.log('Navigating back to UserSearch from draft user mode');
                return;
            }

            // If we were previously on ManageRosterSourcesForUserGroup, check if we have the original path
            if (this.props.location.state.returningFromAddGroup) {
                const originalPath = '/wcpp/UserSearch';
                this.props.history.push({
                    pathname: originalPath,
                    state: {
                        searchInfo: this.props.location.state.searchInfo || {
                            userName: '',
                            email: '',
                            tin: '',
                            typeCD: '',
                            groupId: ''
                        }
                    }
                });
                console.log('Navigating back to UserSearch after returning from ManageRosterSourcesForUserGroup');
                return;
            }
        }

        // Default fallback - just go to UserSearch
        this.props.history.push({
            pathname: '/wcpp/UserSearch'
        });
        console.log('Navigating back to UserSearch (default fallback)');
    }

    setFilterTins = (filtered) => {
        console.log(`in fitler set state`)
        if (filtered && filtered.length >= 0) {
            this.setState({ filteredTins: filtered });
        }
        else {
            this.setState({ filteredTins: [] });
        }

    }

    handleGroupAssignment = event => {
        this.setState({ groupAssignment: event.target.value })
    }

    getGroupTINSTable = () => {
        if ((this.state.tins.length > 0) && (this.state.loadTinsTable)) {
            console.log("getting table");
            return (
                <AddUserGroupTINSTable tinsFiltered={this.state.filteredTins} setFilter={this.setFilterTins}
                    tins={this.state.tins} setSelected={this.setSelectedGroupTINS}
                    selected={this.state.selectedGroupTINS} admin={false} />
            );
        }
    }

    handleGroupTinAdd = () => {
        if (isNotEmpty(this.state.grpId) && !isAlpha(this.state.grpId)) {
            this.setState({ showGroupId: false, selectedGroupTINS: [] });
            this.loadTable();
        } else {
            this.addErrorMessage("grpIdError", "Error: Enter a valid group Id");
        }
    }

    handleClearGroupId = () => {
        this.setState({ grpId: '', showGroupId: true, selectedGroupTINS: [], tins: [], filteredTins: [] });
    }

    // Handler for Roster Admin Group Assignment
    handleRosterGroupAssignment = (event) => {
        const value = event.target.value;
        this.setState({ groupAssignment: value });

        if (value === 'existing') {
            this.setState({
                showGroupId: true,
                // Enable Create User functionality for ROAD with existing group assignment
                isCreateUserButtonEnabled: false,
                isSaveDraftButtonEnabled: true
            });
        } else {
            this.setState({
                grpId: '',
                showGroupId: false,
                // Revert to normal state for ROAD with new group assignment
                isCreateUserButtonEnabled: false,
                isSaveDraftButtonEnabled: true
            });
        }
    }

    // Handler for ROUS Group ID
    handleRosterUserGroup = () => {
        if (isNotEmpty(this.state.grpId) && !isAlpha(this.state.grpId)) {
            this.setState({ showGroupId: false });
        } else {
            this.addErrorMessage("grpIdError", "Error: Enter a valid group Id");
        }
    }

    loadTable = () => {
        //1804
        this.clearErrorMessages();
        this.setState({ tins: [], filteredTins: [] });
        AuthenticationService.getFtinsForUser(this.state.grpId)
            .then((response) => {
                const tins = []
                if (isEmpty(response.data)) {
                    this.addErrorMessage("grpIdError", "Error: Enter a valid group Id");
                } else {
                    response.data.forEach(tin => {
                        const date = new Date(tin.createdDate)
                        tin.displayDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
                        tins.push(tin)
                    })
                    this.setState({ tins: tins, filteredTins: tins, loadTinsTable: true });
                }
            }).catch(error => {
                this.setErrorMsg()
                this.setState({ loadTinsTable: false });
                console.log('Error receiving user ftins:' + error);
            })
    }

    showSuccessErrorMessage = () => {
        return (
            <>
                <LoadingMsgBar loadMsg={this.state.loadingMessage} />
                <GlobalMessage message={this.state.errorMsg} />
                <GlobalMessage type='success' message={this.state.successMsg} />

                <div className='App-note-Field App-error-font App-error-color'>
                    Note: Fields marked with an asterisk(*) are required.
                </div></>
        );
    }

    showButtons = () => {
        return (
            <nav>
                {/* Hide CREATE USER button when ROAD or ROUS account type is selected */}
                {!(this.state.accountType === 'ROAD') &&
                    <Button disabled={!this.state.isCreateUserButtonEnabled || !this.state.showTextFields} onClick={this.handleSave}>CREATE USER</Button>
                }
                {/* Show COMPLETE PROFILE button when account type is ROAD and group assignment is existing */}
                {this.state.accountType === 'ROAD' && this.state.groupAssignment === 'existing' &&
                    <Button disabled={!this.state.isSaveDraftButtonEnabled || !this.state.showTextFields} color="primary" onClick={this.handleSave}>COMPLETE PROFILE</Button>
                }
                {this.state.accountType === 'ROAD' &&
                    <Button disabled={!this.state.isSaveDraftButtonEnabled || !this.state.showTextFields} color="primary" onClick={this.handleSaveDraft}>SAVE AS DRAFT</Button>
                }
                {/* Show NEXT button when account type is ROAD and group assignment is new */}
                {this.state.accountType === 'ROAD' && (this.state.groupAssignment === 'new' || this.state.mode === 'draftUser') &&
                    <Button disabled={!this.state.showTextFields} color="primary" onClick={this.gotoGroupPage}>NEXT</Button>
                }
                {this.state.mode === 'draftUser' &&
                    <Button variant="outlined" onClick={this.handleCancel}>CANCEL</Button>
                }
                <Button variant="outlined" onClick={this.handleReset}>RESET</Button>
            </nav>
        );
    }

    render() {

        return (

            <Fragment>

                <div>
                    <h1 className='App-page-label'>Add User </h1>
                    {this.showSuccessErrorMessage()}

                    <div className="step-main">
                        <Grid container direction="row" spacing={8}>
                            <Grid item xs={12} md={6}>
                                <Grid container direction="column">
                                    <Grid item style={{ width: '100%', textAlign: 'left' }}>
                                        <TextField name="accountType" id="accountType" label="Account Type"
                                            error={isNotEmpty(this.state.accountTypeError)} helperText={this.state.accountTypeError}
                                            defaultValue="Select One"
                                            select
                                            value={this.state.accountType}
                                            onChange={this.handleAccountTypeChange}
                                            fullWidth
                                            required
                                        >
                                            <MenuItem key={'Select One'} value={'Select One'}>
                                                {'Select One'}
                                            </MenuItem>
                                            {this.state.accountTypeList.map(type => (
                                                <MenuItem key={type.value} value={type.value}>
                                                    {type.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    {(this.state.showTextFields) ? <>
                                        {(this.state.accountType === 'PRAD' || this.state.accountType === 'NNUS')
                                            ?
                                            <Grid item style={{ width: '100%', textAlign: 'left' }}>
                                                <FormLabel required component="legend">Group Assignment</FormLabel>
                                                <RadioGroup aria-label="position" defaultValue={this.state.groupAssignment} name="position"
                                                    onChange={this.handleGroupAssignment} ref={this.radioButtonRef} row>
                                                    <FormControlLabel
                                                        value='new'
                                                        control={<Radio color="primary" />}
                                                        label="New"
                                                        labelPlacement="end"
                                                        name='New'
                                                    />
                                                    <FormControlLabel
                                                        name='Existing'
                                                        value='existing'
                                                        control={<Radio color="primary" />}
                                                        label="Existing"
                                                        labelPlacement="end"

                                                    />
                                                </RadioGroup>
                                            </Grid> : ''
                                        }

                                        {(((this.state.accountType === 'PRAD' || this.state.accountType === 'NNUS') && (this.state.groupAssignment === 'existing'))
                                            || (this.state.accountType === 'PRUS'))
                                            ?
                                            <Grid item style={{ width: '100%', textAlign: 'left' }}>

                                                <TextField id="grpId" name="grpId" label="Group Id"
                                                    error={isNotEmpty(this.state.grpIdError)} helperText={this.state.grpIdError}
                                                    value={this.state.grpId}
                                                    disabled={!this.state.showGroupId}
                                                    onChange={this.handleInputChange}
                                                    inputProps={{ maxLength: 11 }}
                                                    fullWidth
                                                    required
                                                />
                                            </Grid> : ''}

                                        {((this.state.accountType === 'PRAD') && (this.state.groupAssignment === 'new'))
                                            ?
                                            <Grid item style={{ width: '100%', textAlign: 'left' }}>
                                                <AddUserTinSection
                                                    key={this.state.tinSectionResetKey}
                                                    validationMode="inNetwork"
                                                    onTinsChanged={tins => this.setState({ providersTINs: tins })}
                                                    allowForceAdd={this.props.isAdmin}
                                                />
                                            </Grid>
                                            : null}

                                        {((this.state.accountType === 'PRUS'))
                                            ?
                                            <Grid item style={{ width: '100%', textAlign: 'left' }}>


                                                <Button variant="outlined" onClick={this.handleGroupTinAdd}>DISPLAY TINS</Button>
                                                <Button variant="outlined" onClick={this.handleClearGroupId} >Clear Group Id</Button>
                                                {this.getGroupTINSTable()}
                                            </Grid>
                                            : null}

                                        {((this.state.accountType === 'NNUS') && (this.state.groupAssignment === 'new'))
                                            ?
                                            <Grid item style={{ width: '100%', textAlign: 'left' }}>
                                                <AddUserTinSection
                                                    key={this.state.tinSectionResetKey}
                                                    validationMode="nonNetwork"
                                                    onTinsChanged={tins => this.setState({ nnusTins: tins })}
                                                    externalError={this.state.nnusTinError}
                                                    allowForceAdd={this.props.isAdmin}
                                                />
                                            </Grid>
                                            : null}

                                        {((this.state.accountType === 'ROAD'))
                                            ?
                                            <Grid item style={{ width: '100%', textAlign: 'left' }}>
                                                <FormLabel required component="legend">Group Assignment</FormLabel>
                                                <RadioGroup aria-label="position" defaultValue={this.state.groupAssignment} name="position"
                                                    onChange={this.handleRosterGroupAssignment} row>
                                                    <FormControlLabel
                                                        value='new'
                                                        control={<Radio color="primary" />}
                                                        label="New"
                                                        labelPlacement="end"
                                                        name='New'
                                                    />
                                                    <FormControlLabel
                                                        name='Existing'
                                                        value='existing'
                                                        control={<Radio color="primary" />}
                                                        label="Existing"
                                                        labelPlacement="end"
                                                    />
                                                </RadioGroup>
                                            </Grid>
                                            : null}

                                        {((this.state.accountType === 'ROAD') && (this.state.groupAssignment === 'existing'))
                                            ?
                                            <Grid item style={{ width: '100%', textAlign: 'left' }}>
                                                <TextField id="grpId" name="grpId" label="Group Id"
                                                    error={isNotEmpty(this.state.grpIdError)} helperText={this.state.grpIdError}
                                                    value={this.state.grpId}
                                                    disabled={!this.state.showGroupId}
                                                    onChange={this.handleInputChange}
                                                    inputProps={{ maxLength: 11 }}
                                                    fullWidth
                                                    variant="outlined"
                                                    margin="normal"
                                                    required
                                                />
                                            </Grid>
                                            : null}

                                        {((this.state.accountType === 'ROUS'))
                                            ?
                                            <Grid item style={{ width: '100%', textAlign: 'left' }}>
                                                <TextField id="grpId" name="grpId" label="Group Id"
                                                    error={isNotEmpty(this.state.grpIdError)} helperText={this.state.grpIdError}
                                                    value={this.state.grpId}
                                                    disabled={!this.state.showGroupId}
                                                    onChange={this.handleInputChange}
                                                    inputProps={{ maxLength: 11 }}
                                                    fullWidth
                                                    variant="outlined"
                                                    margin="normal"
                                                    required
                                                />
                                            </Grid>
                                            : null}

                                        {(((this.state.accountType === 'PRAD') || (this.state.accountType === 'PRUS') || (this.state.accountType === 'NNUS'))) ? <>
                                            <Grid item style={{ width: '100%', textAlign: 'left' }}>
                                                <TextField name="affiliation" id="affiliation" label="Affiliation"
                                                    error={isNotEmpty(this.state.affiliationError)} helperText={this.state.affiliationError}
                                                    defaultValue="Select One"
                                                    select
                                                    value={this.state.affiliation}
                                                    onChange={this.handleInputChange}
                                                    fullWidth
                                                    required

                                                >
                                                    <MenuItem key={'Select One'} value={'Select One'}>
                                                        {'Select One'}
                                                    </MenuItem>
                                                    {this.state.affiliationList.map(type => (
                                                        <MenuItem key={type.value} value={type.value}>
                                                            {type.label}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </Grid>
                                            {(isNotEmpty(this.state.affiliation) && (this.state.affiliation === 'OTHER')) ?

                                                <Grid item style={{ width: '100%', textAlign: 'left' }}>
                                                    <TextField id="other" name="other" label="Other"
                                                        error={isNotEmpty(this.state.firstNameError)} helperText={this.state.firstNameError}
                                                        value={this.state.other}
                                                        onChange={this.handleInputChange}
                                                        inputProps={{ maxLength: 40 }}
                                                        fullWidth
                                                        required
                                                    />
                                                </Grid> : null}</>
                                            : ''}


                                        <Grid item style={{ width: '100%', textAlign: 'left' }}>
                                            <TextField id="firstName" name="firstName" label="First Name"
                                                error={isNotEmpty(this.state.firstNameError)} helperText={this.state.firstNameError}
                                                value={this.state.firstName}
                                                onChange={this.handleInputChange}
                                                inputProps={{ maxLength: 40 }}
                                                fullWidth
                                                required
                                            />
                                        </Grid>

                                        <Grid item style={{ width: '100%', textAlign: 'left' }}>
                                            <TextField id="lastName" name="lastName" label="Last Name"
                                                error={isNotEmpty(this.state.lastNameError)} helperText={this.state.lastNameError}
                                                value={this.state.lastName}
                                                onChange={this.handleInputChange}
                                                inputProps={{ maxLength: 40 }}
                                                fullWidth
                                                required
                                            />
                                        </Grid>

                                        <Grid item style={{ width: '100%', textAlign: 'left' }}>
                                            <TextField id="middleInitial" name="middleInitial" label="Middle Initial"
                                                error={isNotEmpty(this.state.middleInitialError)} helperText={this.state.middleInitialError}
                                                value={this.state.middleInitial}
                                                onChange={this.handleInputChange}
                                                inputProps={{ maxLength: 1 }}
                                                fullWidth
                                            />
                                        </Grid>

                                        <Grid item style={{ width: '100%', textAlign: 'left' }}>
                                            <TextField id="phoneNumber" name="phoneNumber" label="Phone Number"
                                                error={isNotEmpty(this.state.phoneNumberError)} helperText={this.state.phoneNumberError}
                                                value={this.state.phoneNumber}
                                                onChange={this.handleInputChange} onBlur={this.handleOnBlurPhoneNum}
                                                inputProps={{ maxLength: 15 }}
                                                fullWidth
                                                required
                                            />
                                        </Grid>

                                        <Grid item style={{ width: '100%', textAlign: 'left' }}>
                                            <TextField id="emailAddress" name="emailAddress" label="Email Address"
                                                error={isNotEmpty(this.state.emailAddressError)} helperText={this.state.emailAddressError}
                                                value={this.state.emailAddress}
                                                onChange={this.handleInputChange}
                                                inputProps={{ maxLength: 120 }}
                                                fullWidth
                                                required
                                            />
                                        </Grid>

                                        {(((this.state.accountType === 'PRAD') || (this.state.accountType === 'PRUS') || (this.state.accountType === 'NNUS') || (this.state.accountType === 'ROAD') || (this.state.accountType === 'ROUS'))) ? <>
                                            <Grid item style={{ width: '100%', textAlign: 'left' }}>
                                                <TextField id="jobTitle" name="jobTitle" label="Job Title"
                                                    error={isNotEmpty(this.state.jobTitleError)} helperText={this.state.jobTitleError}
                                                    value={this.state.jobTitle}
                                                    onChange={this.handleInputChange}
                                                    inputProps={{ maxLength: 120 }}
                                                    fullWidth
                                                    required
                                                />
                                            </Grid>
                                            <Grid item style={{ width: '100%', textAlign: 'left' }}>
                                                <TextField id="companyName" name="companyName" label="Company Name"
                                                    error={isNotEmpty(this.state.companyNameError)} helperText={this.state.companyNameError}
                                                    value={this.state.companyName}
                                                    onChange={this.handleInputChange}
                                                    inputProps={{ maxLength: 120 }}
                                                    fullWidth
                                                    required
                                                />
                                            </Grid>
                                            {/* Only show Company URL for account types other than ROAD and ROUS */}
                                            {(this.state.accountType !== 'ROAD' && this.state.accountType !== 'ROUS') ?
                                                <Grid item style={{ width: '100%', textAlign: 'left' }}>
                                                    <TextField id="companyUrl" name="companyUrl" label="Company Url"
                                                        value={this.state.companyUrl}
                                                        onChange={this.handleInputChange}
                                                        inputProps={{ maxLength: 120 }}
                                                        fullWidth
                                                    />
                                                </Grid> : null}
                                        </> : ''}

                                        {(((this.state.accountType === 'ISAD') || (this.state.accountType === 'IRAD'))) ?
                                            <Grid item style={{ width: '100%', textAlign: 'left' }}>
                                                <TextField id="enlyteEmpId" name="enlyteEmpId" label="Enlyte Employee ID"
                                                    error={isNotEmpty(this.state.enlyteEmpIdError)} helperText={this.state.enlyteEmpIdError}
                                                    value={this.state.enlyteEmpId}
                                                    onChange={this.handleInputChange}
                                                    inputProps={{ maxLength: 120 }}
                                                    fullWidth
                                                    required
                                                />
                                            </Grid> : null}
                                    </> : ''}
                                </Grid>
                            </Grid>

                            {/* Maintenance Privileges Section - Only shown when logged-in user is ISAD and account type is PRAD or PRUS */}
                            {this.shouldShowMaintenancePrivileges() && this.state.showTextFields && (
                                <Grid item xs={12} md={6}>
                                    <Grid container direction="column">
                                        <Grid item style={{ width: "100%", textAlign: "left", marginBottom: "1rem" }}>
                                            <h1 className="App-page-label">Maintenance Privilege(s)</h1>
                                            <Typography variant="body2" style={{ marginBottom: "1rem" }}>
                                                This user can perform the following action(s):
                                            </Typography>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={this.state.providerDemographicsMaintenance}
                                                        onChange={this.handleInputChange}
                                                        name="providerDemographicsMaintenance"
                                                    />
                                                }
                                                label="Provider Demographics Maintenance"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}

                        </Grid>
                    </div>


                    {this.showButtons()}
                </div>
            </Fragment>

        );

    }
}
export default withStyles(styles)(AddUser);